import React, { useState } from "react";
import { Box, Dialog, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { GetPolicyWalletStatement } from "../../Service/_index";
import { Transition } from "../../UiComponents/Transition/Transition";
import Styles from "../AddMoneyToUser/AddMoneyToUser.module.scss";
import WalletStatementView from "./WalletStatementView";

// index.scss forces `.MuiDialog-paper { width: 100% !important }`, so the paper's
// own max-width is what keeps this dialog from touching the screen edges.
const paperProps = { sx: { borderRadius: "12px", maxWidth: "1100px !important" } };

// The view keeps its own state, so every time the dialog opens it starts clean
// (MUI unmounts a closed dialog's content).
const StatementBody = ({ user, onClose, onOpenPolicy }) => {
  const [mobileNumber, setMobileNumber] = useState("");

  return (
    <>
      <Box className={Styles.DialogHeader} sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography id="wallet-statement-title" className={Styles.DialogTitle}>
            Wallet Statement
          </Typography>
          <Typography className={Styles.DialogSubtitle}>
            {[user.userName, mobileNumber].filter(Boolean).join(" · ")}
          </Typography>
        </Box>
        <IconButton aria-label="Close statement" onClick={onClose} sx={{ color: "#ffffff", mt: -0.5, mr: -1 }}>
          <CloseIcon />
        </IconButton>
      </Box>
      <WalletStatementView
        audience="admin"
        fetchStatement={(args) => GetPolicyWalletStatement(user.userId, args)}
        onOpenPolicy={onOpenPolicy}
        onLoaded={(body) => setMobileNumber(body?.user?.mobileNumber || "")}
      />
    </>
  );
};

const WalletStatementDialog = ({ open, user, onClose, onOpenPolicy }) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    maxWidth="lg"
    TransitionComponent={Transition}
    PaperProps={paperProps}
    aria-labelledby="wallet-statement-title"
  >
    {user && <StatementBody key={user.userId} user={user} onClose={onClose} onOpenPolicy={onOpenPolicy} />}
  </Dialog>
);

export default WalletStatementDialog;
